module.exports = "/images/prg_lv.svg?fb87a16b7700bd934ae8672092e81192";